import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "../../axiosClient/userApi";

export const useDeactivateCustomTheme = () => {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (id: number) => {
            const response = await loggedInApiCall.post(
                `/api/custom_themes/${id}/deactivate`,
                {},
                {
                    headers: {
                        "Content-Type": "application/ld+json",
                        Accept: "application/ld+json",
                    },
                },
            );
            return response.data;
        },
        onSuccess: () => {
            // Invalidate custom theme cache to refetch the themes
            queryClient.invalidateQueries(["customTheme"]);
            queryClient.invalidateQueries(["getAllCustomTheme"]);
        },
    });

    return query;
};
